export const litePlatform = 'SkillLab Lite';
export const classicPlatform = 'SkillLab Classic';
export type PlatformType = typeof classicPlatform | typeof litePlatform;

export const getPlatform = (isLite: boolean) => (isLite ? litePlatform : classicPlatform);
